import React from 'react';
import {
  CasePlanAddSection,
  CasePlanSection,
  CasePlanSectionSkeleton,
} from '@orijinworks/frontend-commons';
import {
  CASE_PLAN_SECTION_SKELETON_COUNT,
} from '../../../../constants/reentry-planning.constants';
import { EditableCasePlanSection } from '../EditableCasePlanSection';

export function CasePlanDetailsSections({
  isSectionsLoading,
  isViewOnly = false,
  sections,
  collapsedSections,
  onToggleCollapse,
  onAddWidget,
  onAddSection,
}) {
  if (isSectionsLoading) {
    return <CasePlanSectionSkeleton count={CASE_PLAN_SECTION_SKELETON_COUNT} />;
  }

  const sharedSectionProps = (section) => {
    const props = {
      title: section.title,
      widgets: section.widgets,
      visibleToLearner: false,
      visibleToLearnerDisabled: true,
      collapsed: collapsedSections[section.id] ?? false,
      onToggleCollapse: () => onToggleCollapse(section.id),
    };
 
    if (!isViewOnly) {
      return {
        ...props,
        onVisibleToLearnerChange: () => {},
        onEmptyStateButtonClick: () => onAddWidget(section.id),
        onAddWidget: () => onAddWidget(section.id),
      };
    }
 
    return props;
  };
 
  const renderAddSection = (position, sectionId) => {
    if (isViewOnly) {
      return null;
    }
 
    return (
      <CasePlanAddSection
        key={`add-section-${position}-${sectionId}`}
        onClick={onAddSection}
      />
    );
  };
 
  if (sections.length === 0) {
    return isViewOnly ? null : [renderAddSection('start', 'empty')];
  }

  const sectionElements = sections.flatMap((section) => {
    const sectionProps = sharedSectionProps(section);
 
    const sectionElement = !isViewOnly ? (
      <EditableCasePlanSection
        key={section.id}
        initialDescription={section.description ?? ''}
        {...sectionProps}
      />
    ) : (
      <CasePlanSection
        key={section.id}
        description={section.description ?? ''}
        {...sectionProps}
      />
    );
 
    return isViewOnly ? [sectionElement] : [renderAddSection('before', section.id), sectionElement];
  });
  
  if (!isViewOnly) {
    const lastSection = sections[sections.length - 1];
    sectionElements.push(renderAddSection('after', lastSection.id));
  }
 
  return sectionElements;
}
